import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { fetchApi } from '@/config/axiosSetting.ts';
import { MyFilesListQueryParamsType } from '@/modules/FileList/queries/myFilesList/myFilesListQuery.type.ts';
import { FullFileType } from '@/modules/FileList/types/FileList.type.ts';

export const myFilesListQueryFunction = (
  params: MyFilesListQueryParamsType,
): Promise<PaginationResponseType<FullFileType[]>> =>
  fetchApi.get('my_files/my_files/list/', { params });
